import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { T } from '../traks';
import { Apify } from '../Apify';
import { GroupWeeklyWinnerTabs, NoWeeklyWinners, WeeklyWinnersFull } from '../c/WeeklyWinners';
import { supportsStaticWeeklyWinners } from '../GameConfig';

const GroupWeeklyWinnersMetaResource = Apify('/z/paginated_group_leaderboard', {})
  .with_query_from_props(({ groupId }) => ({
    group_id: groupId,
    offset: 0,
    limit: 1,
  }))
  .with_props_from_response(data => ({
    pageMeta: data || null,
  }));

export default function FullGroupWeeklyWinners(props) {
  const groupId = parseInt(props.group_id, 10);
  if (!groupId || Number.isNaN(groupId)) {
    return <div className="text-danger">Missing group id</div>;
  }

  const Body = GroupWeeklyWinnersMetaResource.wrap(({ pageMeta, loading, error }) => {
    if (!supportsStaticWeeklyWinners(groupId)) {
      return (
        <Container className="py-3">
          <Row className="ad_game_box">
            <Col xs="12" className="py-3">
              <NoWeeklyWinners />
            </Col>
          </Row>
        </Container>
      );
    }

    if (loading) {
      return <div>Loading...</div>;
    }
    if (error) {
      return <div className="text-danger">Kunne ikke hente puljen.</div>;
    }

    return (
      <Container className="py-3">
        <Row className="ad_game_box">
          <Col xs="12" className="py-3">
            <div className="pb-0 ad_150pct mr-auto">
              <span className="fw-bold"><T>Pool</T></span> — {pageMeta ? pageMeta.Name : ''}
            </div>
            <GroupWeeklyWinnerTabs groupId={groupId} selected={1} />
            <WeeklyWinnersFull groupId={groupId} showHeader={false} />
          </Col>
        </Row>
      </Container>
    );
  });

  return <Body groupId={groupId} />;
}



// WEBPACK FOOTER //
// ./src/p/FullGroupWeeklyWinners.js